export const FETCH_AUTH_SESSION_TOKEN = 'FETCH_AUTH_SESSION_TOKEN';